export enum ReportsType {
  PULLOUT = 'pullout',
  DELIVERY = 'delivery',
  RETURN = 'return',
  DEMURRAGE = 'demurrage',
  PERDIEM = 'perdiem',
  STATISTICS = 'statistics',
  'EARLY-WARNING' = 'early-warning'
}
